import { useEffect, useRef } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import { loadConsent } from '@/lib/analytics';
import { trackPixelCompleteRegistration } from '@/lib/metaPixel';

/**
 * Feuert Meta-Pixel "CompleteRegistration" genau im Moment der E-Mail-Bestaetigung
 * (Signup-Redirect mit type=signup), einmal pro Konto (serverseitig via RPC
 * track_registration_once gesichert), nur mit Marketing-Zustimmung und geladenem Pixel.
 * Kein Feuern bei Reload (INITIAL_SESSION -> kein SIGNED_IN) oder ungueltigen Links.
 */
export const MetaPixelRegistrationTracker = () => {
  const { user, signInTick } = useAuth();
  const attemptedRef = useRef(false);

  useEffect(() => {
    if (signInTick === 0) return; // noch kein echtes SIGNED_IN (Reload = INITIAL_SESSION)
    if (attemptedRef.current) return;
    if (!(window as unknown as { __aimupSignupConfirm?: boolean }).__aimupSignupConfirm) return;
    if (!user || !user.email_confirmed_at) return;

    const consent = loadConsent();
    if (!consent?.marketing) return;
    if (!window.__aimupPixelLoaded || !window.fbq) return;

    attemptedRef.current = true;

    (async () => {
      try {
        const { data, error } = await (supabase as any).rpc('track_registration_once');
        if (!error && data === true) {
          trackPixelCompleteRegistration();
          (window as unknown as { __aimupSignupConfirm?: boolean }).__aimupSignupConfirm = false;
        }
      } catch {
        /* noop */
      }
    })();
  }, [signInTick, user]);

  return null;
};
